import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  AfterViewInit,
} from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare interface Event {
  evento: "";
  id: null;
  row: null;
}

declare var $: any;

@Component({
  selector: "app-table-traking",
  templateUrl: "./table-traking.component.html",
  styleUrls: ["./table-traking.component.css"],
})
export class TableTrakingComponent implements OnInit, AfterViewInit {
  @Input() assigned: boolean = false;
  @Input() elements: string[][];

  @Output() out: EventEmitter<Event>;

  public dataTable: DataTable;
  public pages;
  public pagePrev;
  public pageNext;
  public loading;
  public contarElemento = 1;

  constructor(private _route: ActivatedRoute, private _router: Router) {
    this.out = new EventEmitter();
  }

  saveEmit(accion, id, row = null) {
    var send = {
      evento: accion,
      id: id,
      row: row,
    };
    this.out.emit(send);
  }

  ngOnInit() {
    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }

      this.dataTable = {
        headerRow: [
          "id",
          "Type",
          "Freight Carrier",
          "Small Parcel Carrier",
          "PRO Number",
          "Tracking Number",
          "Expected Date",
          "Actions",
        ],
        footerRow: [
          "id",
          "Type",
          "Freight Carrier",
          "Small Parcel Carrier",
          "PRO Number",
          "Tracking Number",
          "Expected Date",
          "Actions",
        ],
        dataRows: this.elements,
      };

      this.loading = "hide";

      let total_pages = Math.ceil(this.elements.length / 10);

      //total paginas
      this.pages = [];
      for (let i = 0; i < total_pages; i++) {
        this.pages.push(i);
      }

      //pagina anterior
      if (page >= 2) {
        this.pagePrev = page - 1;
      } else {
        this.pagePrev = page;
      }

      //pagina siguiente
      if (page < total_pages) {
        this.pageNext = page + 1;
      } else {
        this.pageNext = page;
      }
    });
  }

  ngAfterViewInit() {
    $("#trakingdatatables").DataTable({
      order: [[0, "desc"]],
      dom: "Bflrtip",
      buttons: [
        /*{
            extend: 'copy',
            exportOptions: {
              columns: ':visible'
            }
          },*/ /*
          {
            extend: 'csv',
            exportOptions: {
              columns: ':visible'
            }
          },*/
        {
          extend: "excel",
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: "Excel",
          className: "btn btn-sm btn-outline-success",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "pdf",
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: "PDF",
          className: "btn btn-sm btn-outline-danger",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "print",
          text: '<i class="fa fa-print" aria-hidden="true"></i>',
          titleAttr: "print",
          className: "btn btn-sm btn-outline-primary",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "colvis",
          text: '<i class="fa fa-columns" aria-hidden="true"></i>',
          className: "btn btn-sm btn-outline-info",
          titleAttr: "Column visibility",
        },
      ],
      pagingType: "full_numbers",
      lengthMenu: [
        [5, 10, 25, 50, 100, 200, 500, 1000, -1],
        [5, 10, 25, 50, 100, 200, 500, 1000, "All"],
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
      },
    });
  }
}
